export default "__VITE_ASSET__QTfxTtqh__"